import { createFileRoute } from '@tanstack/react-router';

import { exigirAcceso } from '@/entities/usuario';
import { ProyectoCumplimientoPage } from '@/pages/proyecto-cumplimiento';

/**
 * Tablero de cumplimiento del proyecto: vista principal a la que apunta el
 * listado. Convive con la vista clásica (`/proyectos/$id`, fases/estructura),
 * que queda accesible desde el botón secundario "Ver vista clásica". Se mantiene
 * la clásica en `$id` para preservar sus deep-links (`?tab=...&incidencia=...`).
 */
export const Route = createFileRoute('/_private/proyectos/$id/cumplimiento')({
  beforeLoad: () => exigirAcceso('proyectos'),
  component: ProyectoCumplimientoPage,
});
